import React from 'react';

export default React.createContext({
  modalIsOpen: false,
  bookingFolderId: null,
  setModalIsOpen: () => null,
  setBookingFolderId: () => null
});